/**
 * KARTY OKNA „Utwórz nowe zgłoszenie” — „Sprawy techniczne” i „Wnioski pracownicze”.
 *
 * [polecenie właściciela 2026-09-28] „w oknie Utworz nowe zgloszenie - zrob 2 karty - sprawy techniczne, wnioski
 * pracownicze; jak techniczne wczytuj to co jest teraz, jak wnioski pracownicze, to co mozna zlozyc w sekcji
 * mpracownik.krosno.com/wnioski-hr”.
 *
 * Reguły w osobnym module, żeby dało się je zmierzyć bez montowania okna:
 *  1. OSTATNIO WYBRANA KARTA jest pamiętana per konto (wygoda przeglądarki — wybór karty to nie dane osobowe;
 *     nieczytelna pamięć = karta techniczna, czyli dokładnie to, co okno pokazywało przed tą zmianą).
 *  2. KARTA STARTOWA: ekran, który otworzył okno z KONKRETNĄ sprawą techniczną (wstępny rodzaj / treść, np. „zgłoś
 *     poprawkę” przy sprzęcie), i przywrócony szkic zgłoszenia zawsze wygrywają z pamięcią — człowiek przyszedł
 *     po TO zgłoszenie. Moduł wniosków ukryty (widoczność /wnioski-hr) = zawsze karta techniczna.
 *
 * ⚠ Każdy dostęp do `localStorage` jest w try/catch: tryb prywatny, zablokowane dane witryny i podgląd potrafią rzucić
 * już przy odczycie — okno ma wtedy otworzyć się na karcie technicznej, a nie wywrócić.
 */
export const KARTA = Object.freeze({ techniczne: "techniczne", wnioski: "wnioski" });

const kluczPamieci = (idKonta) => `mpracownik.noweZgloszenie.karta.${idKonta ?? "anon"}`;

const pamiec = () => {
    try {
        return typeof window !== "undefined" ? window.localStorage : null;
    } catch {
        return null;
    }
};

/** Ostatnio wybrana karta tego konta; cokolwiek innego niż „wnioski” = karta techniczna. */
export const odczytajKarte = (idKonta) => {
    try {
        const p = pamiec();
        return p && p.getItem(kluczPamieci(idKonta)) === KARTA.wnioski ? KARTA.wnioski : KARTA.techniczne;
    } catch {
        return KARTA.techniczne;
    }
};

export const zapamietajKarte = (idKonta, karta) => {
    try {
        const p = pamiec();
        if (p) p.setItem(kluczPamieci(idKonta), karta === KARTA.wnioski ? KARTA.wnioski : KARTA.techniczne);
    } catch {
        /* brak pamięci przeglądarki — następne otwarcie zacznie od karty technicznej */
    }
};

/**
 * Karta, na której okno ma się otworzyć.
 * @param {object} p
 * @param {boolean} p.wnioskiDostepne       moduł „Wnioski HR” widoczny dla konta
 * @param {boolean} p.sprawaTechnicznaWskazana  ekran wywołujący podał rodzaj/treść zgłoszenia albo wraca szkic
 * @param {string}  p.zapamietana           wynik `odczytajKarte`
 */
export const kartaStartowa = ({ wnioskiDostepne, sprawaTechnicznaWskazana, zapamietana }) => {
    if (!wnioskiDostepne || sprawaTechnicznaWskazana) return KARTA.techniczne;
    return zapamietana === KARTA.wnioski ? KARTA.wnioski : KARTA.techniczne;
};
